import React from 'react';

import SupplierShow from '@components/shared/suppliers/SupplierShow';
import supplierService from '@services/admin/supplierService';

export default function AdminSupplierShow() {
  return <SupplierShow service={supplierService} role="admin" />;
}
